import { PositionType } from 'data/types';
import { footprintGridToPixel } from 'utils/footprint-shapes-editing';

export const MIN_DRAW_POINT_SPACING_FEET = 0.25;

export function strokeToPolylinePoints(path: PositionType[]): string {
  return path
    .map((point) => {
      const pixel = footprintGridToPixel(point);
      return `${pixel.x},${pixel.y}`;
    })
    .join(' ');
}

export function shouldAppendStrokePoint(
  last: PositionType | undefined,
  next: PositionType
): boolean {
  if (!last) return true;
  return (
    Math.hypot(next.x - last.x, next.y - last.y) >= MIN_DRAW_POINT_SPACING_FEET
  );
}
